import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { getCollections } from '../../../../SingleRequestPage/components/SingleRequestDrawer/helpers/getCollections'
import {
  CheckDataForm,
  CreateServiceRequestFrom,
  DiagnosticFormType,
  ServiceCenterForm,
} from '../types/NewDrawers.types'

export const getCheckDefaultValues = (
  createForm: CreateServiceRequestFrom,
  diagnosticForm: DiagnosticFormType,
  serviceFormData: ServiceCenterForm,
): CheckDataForm => ({
  ...createForm,
  ...diagnosticForm,
  serialNumber: serviceFormData?.serialNumber ?? '',
  serviceCenterMalfunctionId: serviceFormData?.serviceCenterMalfunctionId ?? '',
  serviceCenterComment: serviceFormData?.serviceCenterComment ?? '',
  receiverModelName: serviceFormData?.receiverModelName ?? '',
})

export const checkServiceRequestFormSchema = z
  .object({
    phoneNumber: z
      .string()
      .transform((val) => val.replace(/\D/g, ''))
      .refine((val) => val.length === 11, {
        path: ['root'], // Указываем путь для ошибки
      }),
    address: z
      .string()
      .min(1)
      .refine((val) => !!val.trim()),
    equipmentId: z.string().optional(),
    preferentialCategories: z.array(z.boolean()).optional(),
    surname: z
      .string()
      .min(1)
      .refine((val) => !!val.trim()),
    name: z
      .string()
      .min(1)
      .refine((val) => !!val.trim()),
    patronymic: z
      .string()
      .min(1)
      .refine((val) => !!val.trim()),
    territory: z.string().min(1),
    district: z.string().min(1),
    locality: z.string().min(1),
    addressType: z.string().nullable(),
    house: z.string().optional(),
    building: z.string().optional(),
    apartment: z.string().optional(),
    created: z.string().optional(),
    additionalInfo: z.string().optional(),
    senderId: z.string().min(1),
    isUrgent: z.boolean().optional(),
    incidentTypeId: z.string().min(1),
    malfunction: z.object({
      malfunctionExplanation: z.string(),
      malfunctionTypeId: z.string().min(1),
    }),
    serialNumber: z.string(),
    serviceCenterMalfunctionId: z.string(),
    serviceCenterComment: z.string().optional(),
    receiverModelName: z.string(),
    orderId: z.number().nullable(),
    isRepeatedAppeal: z.boolean(),
  })
  .refine(
    (data) => {
      const { districtOptions } = getCollections(
        data.territory,
        data.district,
        data.locality,
        -1,
      )
      return districtOptions.includes(data.district)
    },
    {
      message: 'invalid',
      path: ['district'],
    },
  )
  .refine(
    (data) => {
      const { localitiesOptions } = getCollections(
        data.territory,
        data.district,
        data.locality,
        -1,
      )
      return localitiesOptions.includes(data.locality)
    },
    {
      message: 'invalid',
      path: ['locality'],
    },
  )

type FormType = z.infer<typeof checkServiceRequestFormSchema>

export const checkDefaultValues: CheckDataForm = {
  incidentTypeId: '',
  malfunction: { malfunctionExplanation: '', malfunctionTypeId: '' },
  serialNumber: '',
  serviceCenterMalfunctionId: '',
  serviceCenterComment: '',
  receiverModelName: '',
  additionalInfo: '',
  address: '',
  addressType: '',
  apartment: '',
  building: '',
  created: '',
  district: '',
  equipmentId: 'Не заполнен',
  house: '',
  locality: '',
  name: '',
  patronymic: '',
  phoneNumber: '',
  preferentialCategories: [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
  ],
  senderId: '',
  surname: '',
  territory: '',
  isUrgent: false,
  orderId: null,
  isRepeatedAppeal: false,
}

export const resolver = zodResolver(checkServiceRequestFormSchema)
